// Generated from api/types.ts. Updated by generate-http-client.mjs.
export const apiRouteTemplates = [
  "/",
  "/.well-known/oauth-authorization-server/auth",
  "/.well-known/oauth-authorization-server/mcp",
  "/.well-known/oauth-protected-resource/mcp",
  "/.well-known/openai-apps-challenge",
  "/api/partners/bringme/webhooks/parcels",
  "/api/partners/cloudmailin/iloq",
  "/api/partners/dico/rest",
  "/api/partners/dico/soap",
  "/api/partners/generic/images",
  "/api/partners/generic/messages",
  "/api/partners/locoia/end-relation",
  "/api/partners/locoia/new-relation",
  "/api/partners/woonbedrijf/end-relation",
  "/api/partners/woonbedrijf/new-relation",
  "/api/v1/account/notification-settings",
  "/api/v1/account/tickets-configuration",
  "/api/v1/addresses",
  "/api/v1/addresses/stats",
  "/api/v1/addresses/types",
  "/api/v1/admin-notifications",
  "/api/v1/admin-notifications/read",
  "/api/v1/admin-notifications/status",
  "/api/v1/admin/assistant-runs",
  "/api/v1/admin/mcp-tokens",
  "/api/v1/admin/portfolio-tickets",
  "/api/v1/admin/portfolio-tickets/filters",
  "/api/v1/admin/portfolio-tickets/ids",
  "/api/v1/admin/portfolio-tickets/read",
  "/api/v1/admin/portfolio-tickets/stats/all-tabs",
  "/api/v1/admin/tickets",
  "/api/v1/admin/tickets/export",
  "/api/v1/admin/tickets/filters",
  "/api/v1/admin/tickets/read",
  "/api/v1/admin/tickets/stats/all-tabs",
  "/api/v1/ai-email-update",
  "/api/v1/alerts-configurations",
  "/api/v1/alerts-configurations/comment-keywords",
  "/api/v1/alerts-configurations/number-of-comments",
  "/api/v1/alerts-configurations/number-of-likes",
  "/api/v1/alerts-configurations/post-keywords",
  "/api/v1/analytics/adoption-rate",
  "/api/v1/analytics/ask-for-help/monthly",
  "/api/v1/analytics/bucket-ticket-lead-time/monthly",
  "/api/v1/analytics/community-feed",
  "/api/v1/analytics/company-adoption-rate",
  "/api/v1/analytics/conversations/monthly",
  "/api/v1/analytics/engaged-residents/monthly",
  "/api/v1/analytics/feeling-at-home",
  "/api/v1/analytics/feeling-at-home/details",
  "/api/v1/analytics/feeling-at-home/export",
  "/api/v1/analytics/feeling-at-home/monthly",
  "/api/v1/analytics/feeling-at-home/suggestions",
  "/api/v1/analytics/message-label-stats",
  "/api/v1/analytics/resident-engagement",
  "/api/v1/analytics/resident-engagement/details",
  "/api/v1/analytics/ticket-lead-time/monthly",
  "/api/v1/analytics/ticket-overview/monthly",
  "/api/v1/analytics/ticket-rating/monthly",
  "/api/v1/analytics/weekly-chat-conversations",
  "/api/v1/analytics/weekly-messages",
  "/api/v1/assistant/chat",
  "/api/v1/assistant/conversations",
  "/api/v1/authentication/status",
  "/api/v1/automated-surveys",
  "/api/v1/automated-surveys/queues",
  "/api/v1/bookable-assets",
  "/api/v1/bookable-assets/bookings",
  "/api/v1/bookable-assets/bookings/export",
  "/api/v1/branded-app-agreements",
  "/api/v1/buildings",
  "/api/v1/calendar",
  "/api/v1/chats/available-users",
  "/api/v1/chats/bot",
  "/api/v1/chats/state",
  "/api/v1/chats/status",
  "/api/v1/community-feed",
  "/api/v1/community-feed/audience",
  "/api/v1/companies",
  "/api/v1/configuration",
  "/api/v1/configuration/brands",
  "/api/v1/constraints",
  "/api/v1/copilot",
  "/api/v1/copilot/stream",
  "/api/v1/documents",
  "/api/v1/documents/file",
  "/api/v1/documents/folder",
  "/api/v1/documents/recently-uploaded",
  "/api/v1/documents/root-folder",
  "/api/v1/events",
  "/api/v1/events/categories",
  "/api/v1/fast-action-items",
  "/api/v1/files/documents",
  "/api/v1/files/images",
  "/api/v1/files/videos",
  "/api/v1/files/videos/chunk/initiate",
  "/api/v1/groups",
  "/api/v1/homepage/announcements",
  "/api/v1/homepage/coming-next",
  "/api/v1/homepage/events",
  "/api/v1/homepage/quick-actions",
  "/api/v1/homepage/quick-actions/configuration",
  "/api/v1/homepage/quick-actions/configuration/audience",
  "/api/v1/homepage/tickets",
  "/api/v1/iloq-key",
  "/api/v1/iloq-key/complete",
  "/api/v1/iloq-key/refresh",
  "/api/v1/iloq-key/reset",
  "/api/v1/images",
  "/api/v1/integrations/bringme",
  "/api/v1/integrations/copilot-prompt-configurations",
  "/api/v1/integrations/dico",
  "/api/v1/integrations/healthdistrict",
  "/api/v1/integrations/homedna",
  "/api/v1/integrations/hubspot",
  "/api/v1/integrations/iloq",
  "/api/v1/integrations/iloq/lock-groups",
  "/api/v1/integrations/iqbi",
  "/api/v1/integrations/jansen-huybregts",
  "/api/v1/integrations/jansen-huybregts/ticket-status-options",
  "/api/v1/integrations/jim",
  "/api/v1/integrations/jim/rooms",
  "/api/v1/integrations/jim/test",
  "/api/v1/integrations/mypup",
  "/api/v1/integrations/officernd",
  "/api/v1/integrations/outlook",
  "/api/v1/integrations/project-api-access",
  "/api/v1/integrations/project-api-access/rotate-key",
  "/api/v1/integrations/rems",
  "/api/v1/integrations/rems/reconciliation-runs",
  "/api/v1/integrations/swoogo",
  "/api/v1/integrations/wunderbricks",
  "/api/v1/integrations/wunderbricks/ticket-status-options",
  "/api/v1/integrations/ziezodan",
  "/api/v1/integrations/ziezodan/synchronisation",
  "/api/v1/integrations/ziezodan/synchronisation/import",
  "/api/v1/intercom/identity",
  "/api/v1/languages",
  "/api/v1/languages/all",
  "/api/v1/languages/base",
  "/api/v1/mass-addresses",
  "/api/v1/mass-addresses/buildings",
  "/api/v1/mass-addresses/projects",
  "/api/v1/mass-messages",
  "/api/v1/mass-messages/groups",
  "/api/v1/mass-messages/projects",
  "/api/v1/mass-surveys",
  "/api/v1/mass-surveys/groups",
  "/api/v1/mass-surveys/projects",
  "/api/v1/message-templates",
  "/api/v1/messages",
  "/api/v1/messages/markAllAsRead",
  "/api/v1/messages/mentions",
  "/api/v1/messages/recent-activity",
  "/api/v1/messages/unread-stats",
  "/api/v1/notification-settings/defaults",
  "/api/v1/notification-settings/self",
  "/api/v1/notifications/app/registration",
  "/api/v1/onboarding-screens",
  "/api/v1/permissions/default/folder",
  "/api/v1/permissions/default/group",
  "/api/v1/permissions/default/repair-category",
  "/api/v1/permissions/default/service-page",
  "/api/v1/permissions/default/type",
  "/api/v1/permissions/roles",
  "/api/v1/polls",
  "/api/v1/portfolio-analytics/bookings-reporting",
  "/api/v1/portfolio-analytics/community-feed-reporting",
  "/api/v1/portfolio-analytics/events-reporting",
  "/api/v1/portfolio-analytics/resident-engagement",
  "/api/v1/portfolio-analytics/tickets-reporting",
  "/api/v1/portfolio-analytics/tickets-reporting/summary",
  "/api/v1/portfolio-integrations/ai",
  "/api/v1/portfolio-integrations/iloq",
  "/api/v1/portfolio-integrations/rems",
  "/api/v1/portfolio-permissions",
  "/api/v1/project",
  "/api/v1/project-connections",
  "/api/v1/project-connections/invites",
  "/api/v1/project-connections/privacy-settings",
  "/api/v1/project-connections/privacy-settings/seen",
  "/api/v1/project-connections/settings",
  "/api/v1/project/details",
  "/api/v1/project/export",
  "/api/v1/project/overview",
  "/api/v1/project/overview/benchmark",
  "/api/v1/project/summary",
  "/api/v1/project/summary/question",
  "/api/v1/registration/validate-code",
  "/api/v1/repair-categories",
  "/api/v1/repair-categories/creatable",
  "/api/v1/resident-groups",
  "/api/v1/resident-notifications",
  "/api/v1/resident-notifications/badge",
  "/api/v1/resident-notifications/status",
  "/api/v1/self",
  "/api/v1/self/address",
  "/api/v1/self/assignable",
  "/api/v1/self/code-of-conduct/agree",
  "/api/v1/self/delete",
  "/api/v1/self/language",
  "/api/v1/self/onboarding",
  "/api/v1/self/privacy-settings",
  "/api/v1/self/projects",
  "/api/v1/servicepartners",
  "/api/v1/servicepartners/categories",
  "/api/v1/servicepartners/iqbi/confirm-address",
  "/api/v1/servicepartners/iqbi/consent",
  "/api/v1/servicepartners/iqbi/consumption",
  "/api/v1/servicepartners/mypup/external/notification",
  "/api/v1/servicepartners/mypup/register",
  "/api/v1/surveys",
  "/api/v1/surveys/feel-at-home-widget",
  "/api/v1/system-groups",
  "/api/v1/ticket-categories",
  "/api/v1/ticket-categories/creatable",
  "/api/v1/ticket-statuses",
  "/api/v1/tickets",
  "/api/v1/tickets/appointment-plannings",
  "/api/v1/tickets/feedback-options",
  "/api/v1/tickets/filters",
  "/api/v1/tickets/jansen-huybregts/plannings",
  "/api/v1/tickets/stats/all-statuses",
  "/api/v1/translations/translate",
  "/api/v1/triggered-alerts",
  "/api/v1/uptime",
  "/api/v1/user-profile-tickets-configuration",
  "/api/v1/user-sign-in-sign-up/verify-email",
  "/api/v1/users",
  "/api/v1/users-multiple",
  "/api/v1/users-multiple/projects-can-invite",
  "/api/v1/users/admins",
  "/api/v1/users/change-email",
  "/api/v1/users/email-exists",
  "/api/v1/users/lookup",
  "/api/v1/users/recent-joined-resident",
  "/api/v1/users/repair-assignees",
  "/api/v1/users/repair-assignees-by-roles",
  "/api/v1/users/resident-invites/housemate",
  "/api/v1/users/stats",
  "/api/v1/users/verify-email-change-code",
  "/api/v1/wallboard/feed",
  "/api/v1/wallboard/snapshot",
  "/api/v1/widgets/active",
  "/api/v2/analytics/bookings-reporting",
  "/api/v2/analytics/bookings-reporting/summary",
  "/api/v2/analytics/community-feed-reporting",
  "/api/v2/analytics/community-feed-reporting/summary",
  "/api/v2/analytics/engaged-residents/monthly",
  "/api/v2/analytics/events-reporting",
  "/api/v2/analytics/events-reporting/summary",
  "/api/v2/analytics/feeling-at-home/details",
  "/api/v2/analytics/feeling-at-home/export",
  "/api/v2/analytics/resident-engagement/details",
  "/api/v2/analytics/tickets-reporting",
  "/api/v2/analytics/tickets-reporting/summary",
  "/api/v2/chats",
  "/api/v2/chats/group",
  "/api/v2/chats/private",
  "/api/v2/community-feed",
  "/api/v2/community-feed/audience",
  "/api/v2/community-feed/view",
  "/api/v2/events",
  "/api/v2/groups",
  "/api/v2/languages",
  "/api/v2/messages",
  "/api/v2/portfolio-chats",
  "/api/v2/portfolio-chats/available-users",
  "/api/v2/portfolio-chats/group",
  "/api/v2/portfolio-chats/permission",
  "/api/v2/portfolio-chats/private",
  "/api/v2/project/summary",
  "/api/v2/quick-reply-message/create-token",
  "/api/v2/quick-reply-ticket/create-token",
  "/api/v2/registration/connect",
  "/api/v2/resident-groups",
  "/api/v2/resident-notifications",
  "/api/v2/resident-notifications/status",
  "/api/v2/self",
  "/api/v2/ticket-categories/creatable",
  "/api/v3/portfolio-analytics/community-pillars",
  "/api/v3/portfolio-analytics/community-support",
  "/api/v3/portfolio-analytics/feeling-at-home",
  "/api/v3/portfolio-analytics/platform-reach",
  "/api/v3/portfolio-analytics/platform-residents",
  "/api/v3/portfolio-analytics/tickets-resolution-time",
  "/api/v3/portfolio-analytics/tickets/ratings",
  "/api/v3/resident-notifications",
  "/api/v3/self",
  "/internal/signalr/broadcast",
  "/mcp/oauth/authorize",
  "/mcp/oauth/register",
  "/mcp/oauth/token",
  "/api/partners/homedna/{ticketId}/process",
  "/api/v1/addresses/{addressId}/relation",
  "/api/v1/addresses/{addressId}/relation/history",
  "/api/v1/addresses/{id}",
  "/api/v1/addresses/{id}/regenerate-location-code",
  "/api/v1/admin-notifications/read/{id}",
  "/api/v1/admin/assistant-runs/{assistantRunId}",
  "/api/v1/admin/mcp-tokens/{tokenId}",
  "/api/v1/admin/portfolio-tickets/stats/{tab}",
  "/api/v1/admin/tickets/{ticketId}",
  "/api/v1/admin/tickets/{ticketId}/activities",
  "/api/v1/admin/tickets/{ticketId}/assignee",
  "/api/v1/admin/tickets/{ticketId}/dico",
  "/api/v1/admin/tickets/{ticketId}/homedna",
  "/api/v1/admin/tickets/{ticketId}/move-to-in-progress",
  "/api/v1/admin/tickets/{ticketId}/reminder",
  "/api/v1/admin/tickets/{ticketId}/reminder/delete",
  "/api/v1/admin/tickets/{ticketId}/rems-send-ticket",
  "/api/v1/admin/tickets/{ticketId}/rems-sync",
  "/api/v1/admin/tickets/{ticketId}/responsibility-suggestion",
  "/api/v1/admin/tickets/{ticketId}/status",
  "/api/v1/admin/tickets/{ticketId}/wunderbricks",
  "/api/v1/admin/tickets/stats/{tab}",
  "/api/v1/ai-email-update/{id}",
  "/api/v1/alerts-configurations/comment-keywords/{id}",
  "/api/v1/alerts-configurations/number-of-comments/{id}",
  "/api/v1/alerts-configurations/number-of-likes/{id}",
  "/api/v1/alerts-configurations/post-keywords/{id}",
  "/api/v1/analytics/adoption-rate/details/{adoptionRateDetailsGraphType}",
  "/api/v1/analytics/feeling-at-home/suggestions/{suggestionId}/read",
  "/api/v1/analytics/feeling-at-home/suggestions/tips/{tipId}/rate",
  "/api/v1/assistant/conversations/{conversationId}",
  "/api/v1/assistant/conversations/{conversationId}/messages",
  "/api/v1/assistant/conversations/{conversationId}/rate",
  "/api/v1/automated-surveys/{id}",
  "/api/v1/automated-surveys/{id}/active-details",
  "/api/v1/automated-surveys/queues/{queueId}/details",
  "/api/v1/bookable-assets/{assetId}",
  "/api/v1/bookable-assets/{assetId}/bookings",
  "/api/v1/bookable-assets/{assetId}/bookings-to-be-cancelled",
  "/api/v1/bookable-assets/{assetId}/bookings/export",
  "/api/v1/bookable-assets/{assetId}/outlook/test",
  "/api/v1/bookable-assets/{assetId}/slots",
  "/api/v1/bookable-assets/{assetId}/statistics",
  "/api/v1/branded-app-agreements/{token}",
  "/api/v1/branded-app-agreements/{token}/confirm",
  "/api/v1/buildings/{id}",
  "/api/v1/chats/{chat}/notification-settings",
  "/api/v1/chats/available-users/{id}",
  "/api/v1/companies/{id}",
  "/api/v1/companies/{id}/members",
  "/api/v1/companies/{id}/regenerate-location-code",
  "/api/v1/configuration/brands/{brand}",
  "/api/v1/documents/{folderId}",
  "/api/v1/documents/{id}/update-view-count",
  "/api/v1/documents/file/{id}",
  "/api/v1/documents/folder/{id}",
  "/api/v1/documents/root-folder/{id}",
  "/api/v1/events/{event}/read",
  "/api/v1/events/{id}",
  "/api/v1/events/{id}/participant-candidates",
  "/api/v1/events/{id}/participants",
  "/api/v1/events/{id}/signoff",
  "/api/v1/events/{id}/signup",
  "/api/v1/fast-action-items/{id}",
  "/api/v1/fast-action-items/{id}/dynamic-url",
  "/api/v1/files/videos/{id}/update-view-count",
  "/api/v1/files/videos/chunk/{uploadId}/complete",
  "/api/v1/groups/{group}/notification-settings",
  "/api/v1/groups/{id}",
  "/api/v1/groups/{id}/ai/generate-header-image",
  "/api/v1/groups/{id}/enable",
  "/api/v1/groups/{id}/follow",
  "/api/v1/groups/{id}/members",
  "/api/v1/groups/{id}/skip-promotion",
  "/api/v1/groups/{id}/unfollow",
  "/api/v1/iloq-key/users/{userId}",
  "/api/v1/iloq-key/users/{userId}/reset",
  "/api/v1/images/{id}/180x180",
  "/api/v1/images/{id}/360x360",
  "/api/v1/images/{id}/90x90",
  "/api/v1/images/{id}/large",
  "/api/v1/integrations/iloq/{lockGroupId}/options",
  "/api/v1/integrations/rems/reconciliation/{dataType}",
  "/api/v1/integrations/rems/reconciliation/{dataType}/apply",
  "/api/v1/integrations/rems/reconciliation/{dataType}/preview",
  "/api/v1/messages-ai/{messageId}/sentiment",
  "/api/v1/messages-ai/{messageId}/topics",
  "/api/v1/messages/{messageId}",
  "/api/v1/messages/{messageId}/change-status",
  "/api/v1/messages/{messageId}/comments",
  "/api/v1/messages/{messageId}/informs",
  "/api/v1/messages/{messageId}/informs/users",
  "/api/v1/messages/{messageId}/issue-status-update",
  "/api/v1/messages/{messageId}/like",
  "/api/v1/messages/{messageId}/likes",
  "/api/v1/messages/{messageId}/markRead",
  "/api/v1/messages/{messageId}/mute",
  "/api/v1/messages/{messageId}/reach",
  "/api/v1/messages/{messageId}/react",
  "/api/v1/messages/{messageId}/read",
  "/api/v1/messages/{messageId}/report",
  "/api/v1/notification-settings/{userId}",
  "/api/v1/notifications/app/registration/{token}",
  "/api/v1/onboarding-screens/{id}",
  "/api/v1/permissions/roles/{id}",
  "/api/v1/polls/{id}",
  "/api/v1/polls/{id}/answers",
  "/api/v1/polls/{id}/reach",
  "/api/v1/polls/{id}/read",
  "/api/v1/polls/{id}/vote",
  "/api/v1/project-connections/{connectionId}/groups",
  "/api/v1/project-connections/{id}",
  "/api/v1/project-connections/{id}/join",
  "/api/v1/project/{id}",
  "/api/v1/project/{id}/styling",
  "/api/v1/repair-categories/{id}",
  "/api/v1/resident-groups/{id}",
  "/api/v1/resident-notifications/{id}",
  "/api/v1/resident-notifications/{id}/read",
  "/api/v1/servicepartners/{id}",
  "/api/v1/servicepartners/{id}/access-link",
  "/api/v1/servicepartners/{id}/read",
  "/api/v1/servicepartners/{id}/update-view-count",
  "/api/v1/surveys/{id}",
  "/api/v1/surveys/{id}/answer",
  "/api/v1/surveys/{id}/export",
  "/api/v1/surveys/{id}/follow-up",
  "/api/v1/surveys/{id}/read",
  "/api/v1/surveys/{id}/suggested-follow-ups",
  "/api/v1/system-groups/{id}",
  "/api/v1/system-groups/{id}/projects",
  "/api/v1/ticket-categories/{id}",
  "/api/v1/ticket-category-tree/{categoryId}",
  "/api/v1/ticket-statuses/{id}",
  "/api/v1/tickets/{ticketId}",
  "/api/v1/tickets/{ticketId}/appointment",
  "/api/v1/tickets/{ticketId}/appointment/change",
  "/api/v1/tickets/{ticketId}/appointment/select",
  "/api/v1/tickets/{ticketId}/comments",
  "/api/v1/tickets/{ticketId}/jansen-huybregts",
  "/api/v1/tickets/{ticketId}/jansen-huybregts/change",
  "/api/v1/tickets/{ticketId}/jansen-huybregts/select",
  "/api/v1/tickets/{ticketId}/rate",
  "/api/v1/tickets/{ticketId}/read",
  "/api/v1/tickets/{ticketId}/suggestion",
  "/api/v1/tickets/appointment-plannings/{planningId}",
  "/api/v1/tickets/jansen-huybregts/plannings/{planningId}",
  "/api/v1/tickets/stats/{statusType}",
  "/api/v1/users/{id}",
  "/api/v1/users/{id}/assignable",
  "/api/v1/users/{id}/deletion-date",
  "/api/v1/users/{userId}",
  "/api/v1/users/{userId}/groups",
  "/api/v1/users/{userId}/projects",
  "/api/v1/users/{userId}/projects-deletable",
  "/api/v1/users/{userId}/user-signup-reminders",
  "/api/v1/widgets/data/{widgetDataType}",
  "/api/v2/analytics/adoption-rate/details/{adoptionRateDetailsGraphType}",
  "/api/v2/analytics/feeling-at-home/details/questions/{questionGroupId}/summary",
  "/api/v2/chats/{id}",
  "/api/v2/chats/{id}/members",
  "/api/v2/chats/{id}/members/add",
  "/api/v2/chats/{id}/members/leave",
  "/api/v2/chats/{id}/members/remove",
  "/api/v2/chats/{id}/pin",
  "/api/v2/chats/{id}/replies",
  "/api/v2/chats/{id}/reply",
  "/api/v2/chats/blocks/{id}",
  "/api/v2/chats/group/{id}",
  "/api/v2/chats/user/{id}",
  "/api/v2/groups/{id}",
  "/api/v2/messages/{messageId}",
  "/api/v2/messages/{messageId}/change-status",
  "/api/v2/portfolio-chats/{id}",
  "/api/v2/portfolio-chats/{id}/members",
  "/api/v2/portfolio-chats/{id}/members/add",
  "/api/v2/portfolio-chats/{id}/members/leave",
  "/api/v2/portfolio-chats/{id}/replies",
  "/api/v2/portfolio-chats/{id}/reply",
  "/api/v2/portfolio-chats/blocks/{id}",
  "/api/v2/portfolio-chats/group/{id}",
  "/api/v2/portfolio-chats/user/{id}",
  "/api/v2/resident-groups/{id}",
  "/api/v2/survey-categories/{surveyCategory}/average-ratings",
  "/api/v2/surveys/{id}",
  "/api/v2/surveys/{id}/export",
  "/api/v2/ticket-categories/creatable/{categoryId}",
  "/api/v2/users/{id}/delete",
  "/api/v2/users/{userId}/groups",
  "/api/partners/hubspot/projects/{projectId}/webhooks/{webhookSecret}",
  "/api/partners/swoogo/projects/{projectId}/webhooks/{webhookSecret}",
  "/api/v1/addresses/{addressId}/relation/{relationId}",
  "/api/v1/assistant/conversations/{conversationId}/messages/{messageId}/rate",
  "/api/v1/automated-surveys/{id}/analytics/{questionGroupId}",
  "/api/v1/automated-surveys/queues/{queueId}/questions/{questionGroupId}/details",
  "/api/v1/automated-surveys/queues/{queueId}/questions/{questionGroupId}/details/summary",
  "/api/v1/bookable-assets/{assetId}/bookings/{bookingId}",
  "/api/v1/events/{id}/participants/{userId}",
  "/api/v1/files/videos/chunk/{uploadId}/{chunkIndex}",
  "/api/v1/messages/{messageId}/comments/{commentId}",
  "/api/v1/messages/{messageId}/comments/{commentId}/likes",
  "/api/v1/messages/{messageId}/comments/{commentId}/react",
  "/api/v1/polls/{id}/answers/{answerId}",
  "/api/v1/project-connections/{connectionId}/groups/{id}",
  "/api/v1/surveys/{id}/suggested-follow-ups/{followUpId}/rate",
  "/api/v1/surveys/{surveyId}/{questionId}/summary",
  "/api/v1/system-groups/{id}/enable/{projectId}",
  "/api/v1/ticket-category-tree/{categoryId}/{nodeId}",
  "/api/v1/ticket-category-tree/{categoryId}/{nodeId}/disable",
  "/api/v1/ticket-category-tree/{categoryId}/{nodeId}/enable",
  "/api/v1/tickets/{ticketId}/comments/{commentId}",
  "/api/v1/tickets/{ticketId}/history/{ticketHistoryType}",
  "/api/v1/tickets/{ticketId}/translations/{isoCode}",
  "/api/v1/translations/{clientType}/{languageId}",
  "/api/v2/messages/{messageId}/translations/{isoCode}",
  "/api/v2/polls/{id}/translations/{isoCode}",
  "/api/v1/project-connections/{connectionId}/groups/{id}/enable/{projectId}",
  "/api/v1/tickets/{ticketId}/comments/{commentId}/translations/{isoCode}",
  "/api/v2/messages/{messageId}/comments/{commentId}/translations/{isoCode}",
] as const;
